import { formatDateString } from "@circle-react/helpers/dateTimeHelpers/getLocalizedDate";

// `member_since` is the effective (admin-overridable) join date, exposed by the
// serializers ONLY when the `crm_member_since_override_enabled` flag is on — and
// then always as a raw ISO datetime. When the flag is off, some serializers
// (contact/profile) still return a value under the same key, but it's the legacy
// pre-formatted `created_at` string ("June 15, 2025"), not the member_since value.
//
// So we must only treat a raw ISO value as `member_since`; anything else (a
// pre-formatted string, or absent) means the flag is off and we fall back to the
// caller's previous source, preserving pre-override behaviour.
const isRawIsoDate = (value?: string | null): value is string =>
  !!value && /^\d{4}-\d{2}-\d{2}/.test(value);

export const resolveMemberSince = (
  memberSince: string | null | undefined,
  fallback: string | null | undefined,
): string | undefined =>
  isRawIsoDate(memberSince) ? memberSince : (fallback ?? undefined);

// Member-facing surfaces (public profile, profile/DM modals) show the month and
// year only, e.g. "June 2026".
export const formatMemberSinceMonthYear = (
  dateString: string | null | undefined,
): string =>
  dateString
    ? formatDateString(dateString, { month: "long", year: "numeric" })
    : "";
